import { NavLink, Navigate, Route, Routes } from 'react-router-dom';

import Login from './features/Login';
import AssignmentsScreen from './features/assignments/AssignmentsScreen';
import EventAdminScreen from './features/assignments/EventAdminScreen';
import MyAvailability from './features/availability/MyAvailability';
import EventsScreen from './features/events/EventsScreen';
import PersonsScreen from './features/persons/PersonsScreen';
import PlanningScreen from './features/planning/PlanningScreen';
import RolesScreen from './features/roles/RolesScreen';
import PublishedScreen from './features/published/PublishedScreen';
import { useAuth } from './hooks/useAuth';

/**
 * Peu d'écrans, et chacun pour un moment du travail (doc 08) : préparer les
 * dates, répondre sur ses disponibilités, générer, puis vivre avec le planning
 * généré — corriger et exporter, ce qui est l'essentiel du temps passé.
 */
export default function App() {
  const { profile, loading, isAdmin, isManager, signOut } = useAuth();

  if (loading) {
    return (
      <div className="app">
        <main>
          <p className="muted">Chargement…</p>
        </main>
      </div>
    );
  }

  if (!profile) return <Login />;

  return (
    <div className="app">
      <header className="topbar">
        <span className="brand">Planning des équipes</span>
        <span className="row" style={{ alignItems: 'center' }}>
          <span className="who">{profile.email}</span>
          <button className="ghost small" onClick={signOut}>
            Quitter
          </button>
        </span>
      </header>

      <nav className="nav">
        <NavLink to="/planning-publie">Planning</NavLink>
        <NavLink to="/mes-disponibilites">Mes disponibilités</NavLink>
        {isManager && <NavLink to="/evenements">Événements et besoins</NavLink>}
        {isManager && <NavLink to="/personnes">Personnes</NavLink>}
        {isAdmin && <NavLink to="/combinaisons">Combinaisons</NavLink>}
        {isManager && <NavLink to="/generer">Générer</NavLink>}
        {isManager && <NavLink to="/affectations">Affectations</NavLink>}
      </nav>

      <main>
        <Routes>
          <Route path="/planning-publie" element={<PublishedScreen />} />
          <Route path="/mes-disponibilites" element={<MyAvailability />} />
          {isManager && <Route path="/evenements" element={<EventsScreen />} />}
          {isManager && <Route path="/personnes" element={<PersonsScreen />} />}
          {isAdmin && <Route path="/combinaisons" element={<RolesScreen />} />}
          {isManager && <Route path="/generer" element={<PlanningScreen />} />}
          {isManager && <Route path="/affectations" element={<AssignmentsScreen />} />}
          {isManager && (
            <Route
              path="/affectations/:runId/:eventId"
              element={<EventAdminScreen />}
            />
          )}
          <Route
            path="*"
            element={<Navigate to={isManager ? '/generer' : '/planning-publie'} replace />}
          />
        </Routes>
      </main>
    </div>
  );
}
